import styled, { css } from 'styled-components'

import { BlockHeader } from '../../styles/defaults'
import { minmedia, maxmedia } from '../../styles/media-queries'
import { white, gray, gold, bordergray } from '../../styles/colors'

export const Box = styled.div`
  width: 100%;
  background: ${white};
  border: 1px solid ${bordergray};

  ${maxmedia.large`
    border: 0;

    &:first-child {
      border-top: 1px solid ${bordergray};
    }
  `}
  ${minmedia.large`
    width: calc(100%/2 - .5rem);
    border-radius: 0.25rem;
    margin-bottom: 1rem;

    &:last-child {
      width: 100%;
      margin-bottom: 0;
    }
  `}
  ${minmedia.xmlarge`
    width: calc(100%/3 - 1rem);
    margin-bottom: 0;

    &:last-child {
      width: calc(100%/3 - 1rem);
    }
  `}

  a {
    text-decoration: none;
  }
`

export const BoxHeader = BlockHeader.extend`
  ${maxmedia.large`
    cursor: pointer;
  `}
  ${minmedia.large`
    & > div:last-child {
      display: none; // hide plusminus
    }
  `}
`

export const ItemList = styled.div`
  transition: max-height .5s;
  margin: 0;

  ${maxmedia.large`
    max-height: 0;
    overflow: hidden;

    ${props => props.active && css`
      max-height: 999px;
      border-bottom: 1px solid ${bordergray};
    `}
  `}
`

export const ItemListInner = styled.div`
  padding: 1rem;
  overflow: hidden;

  ${minmedia.medium`
    padding: 1rem 1.5rem;
  `}
  ${minmedia.large`
    padding: 1rem 2rem;
  `}
`

export const Item = styled.div`
  margin: 1rem 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  ${minmedia.medium`
    margin: 1.25rem 0;
  `}
`

export const ItemName = styled.div`
  font-weight: 600;
  margin-bottom: 0.5rem;
  ${minmedia.xmlarge`
    width: 100%;
    font-weight: 400;
  `}
  ${minmedia.xxlarge`
    width: 110px;
    font-weight: 300; //reset
    margin-bottom: 0; //reset
  `}
  @media screen and (min-width: 1600px) {
    width: 160px;
  }
`

export const ItemContent = styled.div`
  width: 100%;

  ${minmedia.xmlarge`
    width: 100%;
  `}
  ${minmedia.xxlarge`
    width: calc(100% - 120px);
  `}
  @media screen and (min-width: 1600px) {
    width: calc(100% - 160px);
  }

  span {
    display: block;

    &:nth-of-type(2) {
      margin-top: .5rem;
    }
  }
`

export const ItemLink = styled.a`
  transition: border-color .5s;
  color: ${gold};
  border-bottom: 1px solid ${gold};

  &:hover {
    border-bottom-color: transparent;
  }
`

export const IconContainer = styled.div`
  margin-left: .5rem;
  cursor: pointer;

  ${maxmedia.large`
    display: none;
  `}

  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${gray};
  }

  &:hover {
    svg {
      fill: ${gold};
    }
  }
`

export const Edit = styled.div`
  color: ${gray};
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  cursor: pointer;
  padding: .5rem 0;

  ${minmedia.medium`
    font-size: 16px;
  `}
  ${minmedia.large`
    display: none;
  `}

  &:hover {
    color: ${gold};

    svg {
      fill: ${gold};
    }
  }
`

export const EditIconContainer = styled.div`
  margin-right: .75rem;
  margin-top: .15rem; //v-align better

  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: ${gray};
  }
`



// WEBPACK FOOTER //
// ./src/components/Detail/styles.js